import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useBannerSize } from '../../../../common/hooks/use-banner-size';
import { EvseType } from '../../types';
import { BannerDivider, ChargeSpeedCell } from './banner-cells';
import { COLOR_NUMBER } from './banner-colors';

export function EvseSmartAmpStoppedContent({
  powerFormatted,
  evseType,
}: {
  powerFormatted: string;
  evseType: EvseType;
}) {
  const { h, fontSize } = useBannerSize();
  const { t } = useTranslation();
  return (
    <Flex align="center" w="100%" h={h}>
      <Box flex={1} textAlign="center" pr={2}>
        <Text fontSize={fontSize} color={COLOR_NUMBER} _dark={{ color: 'white' }} letterSpacing="wider">
          {t('EVSE.stopped')}
        </Text>
        <Text fontSize="sm">{evseType === 'SmartPlug' ? t('SmartPlug.name') : t('SmartAmp.name')}</Text>
      </Box>
      <BannerDivider />
      <ChargeSpeedCell powerFormatted={powerFormatted} />
    </Flex>
  );
}
